import { render, staticRenderFns } from "./CamaraEnVivo.vue?vue&type=template&id=37910223&scoped=true&"
import script from "./CamaraEnVivo.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivo.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivo.vue?vue&type=style&index=0&id=37910223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37910223",
  null
  
)

export default component.exports